module.exports = __webpack_public_path__ + "static/favicon-592e92a5eb95bfe2876da59cd921342e.ico";